const state = {
  sessionId: undefined,
  token: undefined,
  phone: undefined,
  marketplaceInfo: undefined,
  flagsData: undefined,
  reKyc: undefined,
  isSetReKyc: undefined,
  notificationList: undefined,
  flagsAllData: undefined,
  guarantorLoanId: undefined,
  guarantorData: undefined,
  isGuarantor: undefined
};
export default state;
